webpackJsonp([104101334113578],{

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.setDefaultProps = setDefaultProps;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(10);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bindRaf = __webpack_require__(345);
	
	var _classnames = __webpack_require__(180);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global window, document */
	
	
	var OnVisible = function (_Component) {
	    _inherits(OnVisible, _Component);
	
	    function OnVisible() {
	        var _ref;
	
	        _classCallCheck(this, OnVisible);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        var _this = _possibleConstructorReturn(this, (_ref = OnVisible.__proto__ || Object.getPrototypeOf(OnVisible)).call.apply(_ref, [this].concat(args)));
	
	        _this.onScroll = (0, _bindRaf.bindRaf)(_this.onScroll.bind(_this));
	        _this.state = {
	            visible: false,
	            bottom: 0,
	            top: 0
	        };
	        return _this;
	    }
	
	    _createClass(OnVisible, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.onScroll();
	            window.addEventListener('scroll', this.onScroll);
	            window.addEventListener('resize', this.onScroll);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.stopListening();
	        }
	    }, {
	        key: 'onScroll',
	        value: function onScroll() {
	            var _this2 = this;
	
	            var pos = window.pageYOffset + window.innerHeight;
	            var visbleTriggerRatio = this.props.percent && this.props.percent / 100 || 0.5;
	            var box = this.holder.getBoundingClientRect();
	
	            var pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
	            var docTop = document.documentElement.clientTop || 0;
	
	            var top = box.top + box.height * visbleTriggerRatio + (pageYOffset - docTop);
	            var isVisible = top < pos;
	            var end = function end() {
	                _this2.props.onChange(_this2.state.visible);
	            };
	
	            if (isVisible) {
	                this.setState(function () {
	                    return {
	                        visible: true,
	                        top: top
	                    };
	                }, end);
	                if (!this.props.bounce) {
	                    this.stopListening();
	                }
	            } else if (this.state.visible) {
	                this.setState(function () {
	                    return {
	                        visible: false
	                    };
	                }, end);
	            }
	        }
	    }, {
	        key: 'stopListening',
	        value: function stopListening() {
	            window.removeEventListener('scroll', this.onScroll);
	            window.removeEventListener('resize', this.onScroll);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var visible = this.state.visible;
	
	            var classes = (0, _classnames2.default)(this.props.className, _defineProperty({}, this.props.visibleClassName || 'visible', visible));
	
	            var invokingProps = {
	                style: this.props.style,
	                className: classes,
	                ref: function ref(el) {
	                    _this3.holder = el || _this3.holder;
	                }
	            };
	
	            return _react2.default.createElement(this.props.wrappingElement, invokingProps, this.props.children);
	        }
	    }]);
	
	    return OnVisible;
	}(_react.Component);
	
	OnVisible.defaultProps = {
	    onChange: function onChange() {}, // eslint-disable-line no-empty-function
	    bounce: false,
	    wrappingElement: 'div'
	};
	
	OnVisible.propTypes = {
	    className: _propTypes2.default.string,
	    style: _propTypes2.default.object,
	    visibleClassName: _propTypes2.default.string,
	    children: _propTypes2.default.node,
	    percent: _propTypes2.default.number,
	    onChange: _propTypes2.default.func,
	    bounce: _propTypes2.default.bool,
	    wrappingElement: _propTypes2.default.string
	};
	
	exports.default = OnVisible;
	function setDefaultProps(props) {
	    Object.keys(props).forEach(function (key) {
	        OnVisible.defaultProps[key] = props[key];
	    });
	}

/***/ }),

/***/ 345:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var bindRaf = exports.bindRaf = function bindRaf(fn) {
	    var isRunning = null;
	    var args = null;
	
	    var run = function run() {
	        isRunning = false;
	        fn.apply(undefined, _toConsumableArray(args));
	    };
	
	    return function () {
	        for (var _len = arguments.length, invokingArguments = Array(_len), _key = 0; _key < _len; _key++) {
	            invokingArguments[_key] = arguments[_key];
	        }
	
	        args = invokingArguments;
	
	        if (isRunning) {
	            return;
	        }
	
	        isRunning = true;
	        requestAnimationFrame(run);
	    };
	};

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _gatsbyLink = __webpack_require__(29);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(139);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactOnVisible = __webpack_require__(344);
	
	var _reactOnVisible2 = _interopRequireDefault(_reactOnVisible);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index() {
	    _classCallCheck(this, Index);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Index.prototype.render = function render() {
	    var aboutData = this.props.data.allContentfulAbout.edges[0].node;
	    console.log("Created by -> www.joshuawootonn.com");
	    return _react2.default.createElement(
	      'div',
	      { className: 'about-wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'columns vertical-spacer row-1' },
	        _react2.default.createElement(
	          'div',
	          { className: 'column is-6-tablet is-12-mobile  text-box-1' },
	          _react2.default.createElement(
	            'div',
	            { className: 'text-wrapper-1' },
	            _react2.default.createElement('div', {
	              dangerouslySetInnerHTML: {
	                __html: aboutData.row1.childMarkdownRemark.html
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'column relative height  is-12-mobile  is-hidden-mobile' },
	          _react2.default.createElement(
	            _reactOnVisible2.default,
	            { className: 'about-image-wrapper-1' },
	            _react2.default.createElement(_gatsbyImage2.default, { sizes: aboutData.images[0].sizes, className: 'about-image' }),
	            _react2.default.createElement('div', { className: 'visible-cover' })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'columns vertical-spacer row-2' },
	        _react2.default.createElement(
	          'div',
	          { className: 'column relative height is-6-tablet is-hidden-mobile' },
	          _react2.default.createElement(
	            _reactOnVisible2.default,
	            { className: 'about-image-wrapper-2' },
	            _react2.default.createElement(_gatsbyImage2.default, { sizes: aboutData.images[1].sizes, className: 'about-image' }),
	            _react2.default.createElement('div', { className: 'visible-cover' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'column is-6-desktop is-12-mobile  text-box-2' },
	          _react2.default.createElement(
	            'div',
	            { className: 'text-wrapper-2' },
	            _react2.default.createElement('div', {
	              dangerouslySetInnerHTML: {
	                __html: aboutData.row2.childMarkdownRemark.html
	              }
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return Index;
	}(_react.Component);
	
	exports.default = Index;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-index-js-9cc8320b07d6c100405d.js